<!-- <div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter Passport Details</h5>
    <form [formGroup]="passportForm" novalidate>
        <div class="row mx-0 mt-4">
             
            <div class="col-lg-6 pe-lg-5 pe-md-2"  >
                <nri-app-img-upld [imageName]="'Passport Front'" (imageURL)="imageURL($event)" #passportimg1 (getOcrDatas)="getOCR($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport1Imgempty">
                    Please upload your passport front image
                </div>
               
            </div>

            <div class="col-lg-6 pe-lg-5 pe-md-2" >     
                <nri-app-img-upld [imageName]="'Passport Back'" (imageURL)="imageURL($event)" #passportimg2 (getOcrDatas)="getOCR($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport2Imgempty">
                    Please upload your passport back image
                </div>          
               
            </div>
        </div>
        <div class="row mx-0 mt-4" >
            <div class="col-lg-6 pe-lg-5 pe-md-2 order-1">
                <div class="form-floating" [ngClass]="passportForm.controls.PassportNo.touched && passportForm.controls.PassportNo.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" autocomplete="off"  maxlength="30" formControlName="PassportNo" id="passport" placeholder="Passport No" appAlphanumeric [ngClass]="passportForm.controls.PassportNo.value ? 'has-value' : ''">
                    <label for="passport">Enter Passport No. <span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.PassportNo.touched && passportForm.controls.PassportNo.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Please enter passport number.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 order-md-2 order-4">
                <div class="form-floating" [ngClass]="passportForm.controls.PassportName.touched && passportForm.controls.PassportName.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="PassportName" autocomplete="off" maxlength="120" id="passportName" placeholder="Passport Name" (input)="onInputChange($event)" (blur)="spaceValidation($event, 'PassportName')" [ngClass]="passportForm.controls.PassportName.value ? 'has-value' : ''">
                    <label for="passportName">Enter Name as per Passport <span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.PassportName.touched && passportForm.controls.PassportName.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Please enter your passport name.</span>
                    </div>
                </div>
            </div>
           
        </div>
        <div class="row mx-0" >

            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="input-group rounded-2 border form-floating" [ngClass]="expiryDateError || (passportForm.controls.PassportExpiry.touched && passportForm.controls.PassportExpiry.errors) ? 'mb-md-2 mb-2':'mb-md-5 mb-4'">
                    <input class="form-control mt-2  border-0 pe-0  py-0" readonly formControlName="PassportExpiry" placeholder="Enter Passport Expiry" ngx-mydatepicker (click)="dp.toggleCalendar();openCalendarAndDetectChanges(dp)" name="mydate"
                     [options]="options" id="pExpiry" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event)" required [ngClass]="passportForm.controls.PassportExpiry.value ? 'has-value' : ''"/>
                    <label for="pExpiry" class="calendar">Select Passport Expiry <span class="text-danger">*</span></label>
                    <span class="px-3 py-2">
                        <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                    </span>
                </div>
                <div *ngIf="passportForm.controls.PassportExpiry.touched && passportForm.controls.PassportExpiry.errors?.['required']" class="ms-3 mt-0">
                    <span class="small text-danger">Please select passport expiry date.</span>
                </div>
                <div *ngIf="expiryDateError" class="mb-md-5 mb-4">
                    <span class="small text-danger">Passport must be valid atleast 3 months from the present date.</span>
                </div>
                
                <div class="form-floating mt-2 mb-md-5 mb-4">
                    <select class="form-select" [ngClass]="passportForm.controls.Nationality.value ? 'has-value':'optionValue'" formControlName="Nationality" id="country" (change)="getCountryName()">
                        <option [value]="list.Id" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                    </select>
                    <label for="country" [ngClass]="passportForm.controls.Nationality.value ? '':'form-select-label'">Select Nationality <span class="text-danger">*</span></label>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="px-md-2 px-0 mb-4">
                    <strong>Marital Status <span class="text-danger">*</span></strong>
                    <div class="mt-1 d-md-flex row row-cols-auto">
                        <div class="col">
                            <input class="ms-0 form-check-input" formControlName="MaritalStatus" name="MaritalStatus" type="radio" value="M" id="ma">
                            <label class="form-check-label ps-2" for="ma">Married</label>
                        </div>
                        <div class="col">
                            <input class="ms-lg-3 form-check-input" formControlName="MaritalStatus" name="MaritalStatus" type="radio" value="S" id="un">
                            <label class="form-check-label ps-2" for="un">Single</label>
                        </div>
                    </div>
                </div>
                <div class="px-md-2 px-0 mb-5">
                    <strong>Gender <span class="text-danger">*</span></strong>
                    <div class="mt-2 d-md-flex row row-cols-auto">
                        <div class="col">
                            <input class="ms-0 form-check-input" name="Gender" formControlName="Gender" type="radio" value="M" id="male">
                            <label class="form-check-label ps-2" for="male">Male</label>
                        </div>
                        <div class="col">
                            <input class="ms-lg-3 form-check-input" name="Gender" formControlName="Gender" type="radio" value="F" id="female">
                            <label class="form-check-label ps-2" for="female">Female</label>
                        </div>
                        <div class="col mt-3 mt-md-0">
                            <input class="ms-md-0 form-check-input" name="Gender" formControlName="Gender" type="radio" value="T" id="trans">
                            <label class="form-check-label ps-2" for="trans">Transgender</label>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="input-group rounded-2 border form-floating" [ngClass]="(passportForm.controls.dateOfIssue.touched && passportForm.controls.dateOfIssue.errors) ? 'mb-md-2 mb-2':'mb-md-5 mb-4'">
                    <input class="form-control mt-2  border-0 pe-0  py-0" readonly formControlName="dateOfIssue" placeholder="Enter Date of Issue" ngx-mydatepicker (click)="dateOfissue.toggleCalendar();openCalendarAndDetectChanges(dateOfissue)" name="dateOfissue"
                     [options]="dateOfIssueOptions" id="dateOfissue" #dateOfissue="ngx-mydatepicker" (dateChanged)="dateIssueEvent($event)" required [ngClass]="passportForm.controls.dateOfIssue.value ? 'has-value' : ''"/>
                    <label for="dateOfissue" class="calendar">Select Date Of Issue<span class="text-danger">*</span></label>
                    <span class="px-3 py-2">
                        <img src="./assets/images/Calendar.svg" (click)="dateOfissue.toggleCalendar()">
                    </span>
                </div>
                <div *ngIf="passportForm.controls.dateOfIssue.touched && passportForm.controls.dateOfIssue.errors?.['required']" class="ms-3 mt-0">
                    <span class="small text-danger">Please select Date of Issue.</span>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="form-floating" [ngClass]="passportForm.controls.Placeofbirth.touched && passportForm.controls.Placeofbirth.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="Placeofbirth" autocomplete="off" maxlength="120" id="Placeofbirth" placeholder="Place of Birth" appAlphabetsOnly [ngClass]="passportForm.controls.Placeofbirth.value ? 'has-value' : ''">
                    <label for="Placeofbirth">Enter place of birth as per Passport <span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.Placeofbirth.touched && passportForm.controls.Placeofbirth.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Please Enter place of birth as per Passport</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="form-floating" [ngClass]="passportForm.controls.PlaceOfIssue.touched && passportForm.controls.PlaceOfIssue.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="PlaceOfIssue" autocomplete="off" maxlength="120" id="Place" placeholder="Place of Issue Country" appAlphabetsOnly [ngClass]="passportForm.controls.PlaceOfIssue.value ? 'has-value' : ''">
                    <label for="Place">Enter Place of Issue Country<span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.PlaceOfIssue.touched && passportForm.controls.PlaceOfIssue.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Enter Place of Issue Country</span>
                    </div> 
                </div>
            </div>
             <div class="col-lg-6 pe-lg-5 pe-md-2">
            <div class="px-md-2 px-0 mb-5">
                <strong>Passport Type <span class="text-danger">*</span></strong>
                <div class="mt-2 d-md-flex row row-cols-auto">
                    <div class="col">
                        <input class="ms-0 form-check-input" name="POIOCI" formControlName="POIOCI" type="radio" value="N" id="nri" >
                        <label class="form-check-label ps-2" for="nri">Indian Passport</label>
                    </div>
                    <div class="col">
                        <input class="ms-lg-3 form-check-input" name="POIOCI" formControlName="POIOCI" type="radio" value="F" id="foreign" >
                        <label class="form-check-label ps-2" for="foreign">Foreign Passport</label>
                    </div>
                </div>
            </div>
            </div>
             
            </div>

            
        
    </form>
    <div class="d-flex align-items-end  mx-0 mt-5 pt-5 row">
        <div class="col-6 p-0 ">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end  p-0">
            <button class="btn btn-primary px-4" [disabled]="!passportForm.valid || expiryDateError" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal> -->


<div>
    <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-4">Enter Passport Details</h5>
    <form [formGroup]="passportForm" novalidate>
        <div class="row mx-0 mt-4">
            <div class="col-lg-6 pe-lg-5 pe-md-2">
            <div class="px-md-2 px-0 mb-5">
                <strong>Passport Type <span class="text-danger">*</span></strong>
                <div class="mt-2 d-md-flex row row-cols-auto">
                    <div class="col">
                        <input class="ms-0 form-check-input" name="POIOCI" formControlName="POIOCI" type="radio" value="N" id="nri" (change)="onPassportTypeChange($event)">
                        <label class="form-check-label ps-2" for="nri">Indian Passport</label>
                    </div>
                    <div class="col">
                        <input class="ms-lg-3 form-check-input" name="POIOCI" formControlName="POIOCI" type="radio" value="F" id="foreign" (change)="onPassportTypeChange($event)">
                        <label class="form-check-label ps-2" for="foreign">Foreign Passport</label>
                    </div>
                </div>
            </div>
            </div>
             <div class="col-lg-6 pe-lg-5 pe-md-2">
           
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2"  *ngIf="passportForm.get('POIOCI')?.value === 'N' && passportype">
                <nri-app-img-upld [imageName]="'Passport Front'" (imageURL)="imageURL($event)" #passportimg1 (getOcrDatas)="getOCR($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport1Imgempty">
                    Please upload your passport front image
                </div>
                <!-- <div class="px-0 mb-4">
                    <div class="form-floating mb-md-5 mb-4">
                        <select class="form-select" formControlName="Occupation" id="occupation">
                            <option *ngFor="let list of occupationList; let i = index" [value]="list.OccupationId">{{list.Name}}</option>
                        </select>
                        <label for="occupation" [ngClass]="passportForm.controls.Occupation.value ? '':'form-select-label'">Select Occupation <span class="text-danger">*</span></label>
                    </div>
                </div> -->
            </div>

            <div class="col-lg-6 pe-lg-5 pe-md-2"  *ngIf="passportForm.get('POIOCI')?.value === 'N' && passportype">     
                <nri-app-img-upld [imageName]="'Passport Back'" (imageURL)="imageURL($event)" #passportimg2 (getOcrDatas)="getOCR($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport2Imgempty">
                    Please upload your passport back image
                </div>          
                <!-- <div class="form-floating mb-md-5 mb-4">
                    <select class="form-select " id="income" formControlName="AnnualIncome">
                        <option *ngFor="let list of incomeList; let i = index" [value]="list.Id">{{list.Values}}</option>
                    </select>
                    <label for="income" [ngClass]="passportForm.controls.AnnualIncome.value ? '':'form-select-label'">Annual Income (in INR) <span class="text-danger">*</span></label>
                </div> -->
            </div>
        </div>
        <div class="row mx-0 mt-4" *ngIf="passportype">
            <div class="col-lg-6 pe-lg-5 pe-md-2 order-1">
                <div class="form-floating" [ngClass]="passportForm.controls.PassportNo.touched && passportForm.controls.PassportNo.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" autocomplete="off"  maxlength="30" formControlName="PassportNo" id="passport" placeholder="Passport No" appAlphanumeric [ngClass]="passportForm.controls.PassportNo.value ? 'has-value' : ''">
                    <label for="passport">Enter Passport No. <span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.PassportNo.touched && passportForm.controls.PassportNo.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Please enter passport number.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2 order-md-2 order-4">
                <div class="form-floating" [ngClass]="passportForm.controls.PassportName.touched && passportForm.controls.PassportName.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="PassportName" autocomplete="off" maxlength="120" id="passportName" placeholder="Passport Name" (input)="onInputChange($event)" (blur)="spaceValidation($event, 'PassportName')" [ngClass]="passportForm.controls.PassportName.value ? 'has-value' : ''">
                    <label for="passportName">Enter Name as per Passport <span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.PassportName.touched && passportForm.controls.PassportName.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Please enter your passport name.</span>
                    </div>
                </div>
            </div>
            <!-- <div class="col-lg-6 pe-lg-5 pe-md-2 order-md-3 order-2">
                <nri-app-img-upld [imageName]="'Passport Front'" (imageURL)="imageURL($event)" #passportimg1></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport1Imgempty">
                    Please upload your passport front image
                </div>
            </div> -->
            <!-- <div class="col-lg-6 pe-lg-5 pe-md-2 order-md-4 order-3">
                <nri-app-img-upld [imageName]="'Passport Back'" (imageURL)="imageURL($event)" #passportimg2></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport2Imgempty">
                    Please upload your passport back image
                </div>
            </div> -->
        </div>
        <div class="row mx-0" *ngIf="passportype">

            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="input-group rounded-2 border form-floating" [ngClass]="expiryDateError || (passportForm.controls.PassportExpiry.touched && passportForm.controls.PassportExpiry.errors) ? 'mb-md-2 mb-2':'mb-md-5 mb-4'">
                    <input class="form-control mt-2  border-0 pe-0  py-0" readonly formControlName="PassportExpiry" placeholder="Enter Passport Expiry" ngx-mydatepicker (click)="dp.toggleCalendar();openCalendarAndDetectChanges(dp)" name="mydate"
                     [options]="options" id="pExpiry" #dp="ngx-mydatepicker" (dateChanged)="onDateChanged($event)" required [ngClass]="passportForm.controls.PassportExpiry.value ? 'has-value' : ''"/>
                    <label for="pExpiry" class="calendar">Select Passport Expiry <span class="text-danger">*</span></label>
                    <span class="px-3 py-2">
                        <img src="./assets/images/Calendar.svg" (click)="dp.toggleCalendar()">
                    </span>
                </div>
                <div *ngIf="passportForm.controls.PassportExpiry.touched && passportForm.controls.PassportExpiry.errors?.['required']" class="ms-3 mt-0">
                    <span class="small text-danger">Please select passport expiry date.</span>
                </div>
                <div *ngIf="expiryDateError" class="mb-md-5 mb-4">
                    <span class="small text-danger">Passport must be valid atleast 3 months from the present date.</span>
                </div>
                
                <div class="form-floating mt-2 mb-md-5 mb-4">
                    <select class="form-select" [ngClass]="passportForm.controls.Nationality.value ? 'has-value':'optionValue'" formControlName="Nationality" id="country" (change)="getCountryName()">
                        <option [value]="list.Id" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                    </select>
                    <label for="country" [ngClass]="passportForm.controls.Nationality.value ? '':'form-select-label'">Select Nationality <span class="text-danger">*</span></label>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="px-md-2 px-0 mb-4">
                    <strong>Marital Status <span class="text-danger">*</span></strong>
                    <div class="mt-1 d-md-flex row row-cols-auto">
                        <div class="col">
                            <input class="ms-0 form-check-input" formControlName="MaritalStatus" name="MaritalStatus" type="radio" value="M" id="ma">
                            <label class="form-check-label ps-2" for="ma">Married</label>
                        </div>
                        <div class="col">
                            <input class="ms-lg-3 form-check-input" formControlName="MaritalStatus" name="MaritalStatus" type="radio" value="S" id="un">
                            <label class="form-check-label ps-2" for="un">Single</label>
                        </div>
                    </div>
                </div>
                <div class="px-md-2 px-0 mb-5">
                    <strong>Gender <span class="text-danger">*</span></strong>
                    <div class="mt-2 d-md-flex row row-cols-auto">
                        <div class="col">
                            <input class="ms-0 form-check-input" name="Gender" formControlName="Gender" type="radio" value="M" id="male">
                            <label class="form-check-label ps-2" for="male">Male</label>
                        </div>
                        <div class="col">
                            <input class="ms-lg-3 form-check-input" name="Gender" formControlName="Gender" type="radio" value="F" id="female">
                            <label class="form-check-label ps-2" for="female">Female</label>
                        </div>
                        <div class="col mt-3 mt-md-0">
                            <input class="ms-md-0 form-check-input" name="Gender" formControlName="Gender" type="radio" value="T" id="trans">
                            <label class="form-check-label ps-2" for="trans">Transgender</label>
                        </div>
                    </div>
                </div>
                
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="input-group rounded-2 border form-floating" [ngClass]="(passportForm.controls.dateOfIssue.touched && passportForm.controls.dateOfIssue.errors) ? 'mb-md-2 mb-2':'mb-md-5 mb-4'">
                    <input class="form-control mt-2  border-0 pe-0  py-0" readonly formControlName="dateOfIssue" placeholder="Enter Date of Issue" ngx-mydatepicker (click)="dateOfissue.toggleCalendar();openCalendarAndDetectChanges(dateOfissue)" name="dateOfissue"
                     [options]="dateOfIssueOptions" id="dateOfissue" #dateOfissue="ngx-mydatepicker" (dateChanged)="dateIssueEvent($event)" required [ngClass]="passportForm.controls.dateOfIssue.value ? 'has-value' : ''"/>
                    <label for="dateOfissue" class="calendar">Select Date Of Issue<span class="text-danger">*</span></label>
                    <span class="px-3 py-2">
                        <img src="./assets/images/Calendar.svg" (click)="dateOfissue.toggleCalendar()">
                    </span>
                </div>
                <div *ngIf="passportForm.controls.dateOfIssue.touched && passportForm.controls.dateOfIssue.errors?.['required']" class="ms-3 mt-0">
                    <span class="small text-danger">Please select Date of Issue.</span>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="form-floating" [ngClass]="passportForm.controls.Placeofbirth.touched && passportForm.controls.Placeofbirth.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="Placeofbirth" autocomplete="off" maxlength="120" id="Placeofbirth" placeholder="Place of Birth" appAlphabetsOnly [ngClass]="passportForm.controls.Placeofbirth.value ? 'has-value' : ''">
                    <label for="Placeofbirth">Enter place of birth as per Passport <span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.Placeofbirth.touched && passportForm.controls.Placeofbirth.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Please Enter place of birth as per Passport</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-lg-5 pe-md-2">
                <div class="form-floating" [ngClass]="passportForm.controls.PlaceOfIssue.touched && passportForm.controls.PlaceOfIssue.errors ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase" formControlName="PlaceOfIssue" autocomplete="off" maxlength="120" id="Place" placeholder="Place of Issue Country" appAlphabetsOnly [ngClass]="passportForm.controls.PlaceOfIssue.value ? 'has-value' : ''">
                    <label for="Place">Enter Place of Issue Country<span class="text-danger">*</span></label>
                    <div *ngIf="passportForm.controls.PlaceOfIssue.touched && passportForm.controls.PlaceOfIssue.errors" class="ms-3 mt-0">
                        <span class="small text-danger">Enter Place of Issue Country</span>
                    </div> 
                </div>
            </div>
             <div class="col-lg-6 pe-lg-5 pe-md-2">
           
            </div>
            <!-- <div class="col-lg-6 pe-lg-5 pe-md-2" *ngIf="showIndianNumber">
                <div class="form-floating" [ngClass]="contactError ? 'mb-3 mb-md-3' : 'mb-4 mb-md-5'">
                    <input type="text" class="form-control text-uppercase"  formControlName="IndianContact"  autocomplete="off" maxlength="10" id="IndianContact" placeholder="Contact" appDigitOnly [ngClass]="passportForm.controls.IndianContact.value ? 'has-value' : ''" (blur)="indianNumCheck()">
                    <label for="IndianContact">Enter Indian Phone Number<span class="text-danger">*</span></label>
                    <div *ngIf="contactError" class="ms-3 mt-0">
                        <span class="small text-danger">{{contactErrorMsg}}</span>
                    </div>
                </div>
            </div> -->
             <div class="col-lg-6 pe-lg-5 pe-md-2"  *ngIf="passportForm.get('POIOCI')?.value === 'F'">
                <nri-app-img-upld [imageName]="'Passport Front'" (imageURL)="imageURL($event)" #passportimg1 (getOcrDatas)="getOCR($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport1Imgempty">
                    Please upload your passport front image
                </div>
                <!-- <div class="px-0 mb-4">
                    <div class="form-floating mb-md-5 mb-4">
                        <select class="form-select" formControlName="Occupation" id="occupation">
                            <option *ngFor="let list of occupationList; let i = index" [value]="list.OccupationId">{{list.Name}}</option>
                        </select>
                        <label for="occupation" [ngClass]="passportForm.controls.Occupation.value ? '':'form-select-label'">Select Occupation <span class="text-danger">*</span></label>
                    </div>
                </div> -->
            </div>

            <div class="col-lg-6 pe-lg-5 pe-md-2"  *ngIf="passportForm.get('POIOCI')?.value === 'F'">     
                <nri-app-img-upld [imageName]="'Passport Back'" (imageURL)="imageURL($event)" #passportimg2 (getOcrDatas)="getOCR($event)"></nri-app-img-upld>
                <div class="text-danger small mb-4" *ngIf="passport2Imgempty">
                    Please upload your passport back image
                </div>          
                <!-- <div class="form-floating mb-md-5 mb-4">
                    <select class="form-select " id="income" formControlName="AnnualIncome">
                        <option *ngFor="let list of incomeList; let i = index" [value]="list.Id">{{list.Values}}</option>
                    </select>
                    <label for="income" [ngClass]="passportForm.controls.AnnualIncome.value ? '':'form-select-label'">Annual Income (in INR) <span class="text-danger">*</span></label>
                </div> -->
            </div>
        </div>
        
    </form>
    <div class="d-flex align-items-end  mx-0 mt-5 pt-5 row" *ngIf="passportype">
        <div class="col-6 p-0 ">
            <button class="btn btn-white border-primary text-primary px-4" (click)="backStage()">Back</button>
        </div>
        <div class="col-6 text-end  p-0">
            <button class="btn btn-primary px-4" [disabled]="!passportForm.valid || expiryDateError" (click)="stageValidate()">Next</button>
        </div>
    </div>
</div>
<ngx-ui-loader></ngx-ui-loader>
<app-error-modal #errorComp></app-error-modal>